// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3374":"9d45caf1","3768":"9d45caf1"}[chunkId] + ".chunk.css";
};